<div class="card bg-2">
    <div class="card-body">
        <mat-horizontal-stepper class="bg-2 form-group row" #stepper (selectionChange)="stepChanged($event)">
            <mat-step label="Regra composta">
                <cadastro-regra #cadastroRegraComposta [composta]="true" [regra]="regra" [isConsulta]="isConsulta" (onFormChange)="updateForm($event)"></cadastro-regra>
            </mat-step>
            <mat-step label="Seleção regras">
                <selecao-regras #selecaoRegras [regra]="regra" [isConsulta]="isConsulta" (onRegraChange)="updateRegrasAssociadas($event)"></selecao-regras>
            </mat-step>
        </mat-horizontal-stepper>
    </div>
</div>
<div class="card mb-5 mt-1 bg-2" *ngIf="!isConsulta">
    <div class="card-footer">
        <div class="d-flex flex-row justify-content-end">
          <div>
            <button mat-raised-button color="primary" title="Gravar" aria-label="left" (click)="gravar()"
                    [disabled]="!(isValid$ | async)">
                <loading-icon [btnLabel]="'Gravar'" [loading]="loading$ | async"></loading-icon>
            </button>
          </div>
        </div>
    </div>
</div>
